// DSGVO-konformes Audit-Log — keine Klarnamen, nur Aktionscodes
// Wird zur Nachweisführung bei Behörden-/Zertifizierungsanfragen genutzt

import { db, type AuditLog } from '../db/schema';

export type { AuditLog };

export async function logAktion(
  firma: string,
  aktion: string,
  details?: Record<string, unknown>,
): Promise<void> {
  try {
    await db.audit_log.add({
      schema_version: 1,
      timestamp:  new Date().toISOString(),
      firma,
      aktion,
      ...(details !== undefined && { details: JSON.stringify(details) }),
      user_agent: navigator.userAgent.slice(0, 150),
    });
    // Auf maximal 1000 Einträge begrenzen (älteste löschen)
    const count = await db.audit_log.count();
    if (count > 1000) {
      const oldest = await db.audit_log.orderBy('id').limit(count - 1000).primaryKeys();
      await db.audit_log.bulkDelete(oldest as number[]);
    }
  } catch {
    // Audit-Log-Fehler nie den normalen Flow unterbrechen
  }
}

export async function loadRecentLog(limit = 100): Promise<AuditLog[]> {
  return db.audit_log.orderBy('id').reverse().limit(limit).toArray();
}

export async function clearAuditLog(): Promise<void> {
  await db.audit_log.clear();
}

export async function exportAuditLogCsv(): Promise<void> {
  const rows = await db.audit_log.orderBy('id').reverse().limit(500).toArray();
  const BOM  = '﻿';
  const header = 'Zeitstempel;Mandant;Aktion;Details\r\n';
  const body   = rows
    .map(r => [
      r.timestamp,
      r.firma,
      r.aktion,
      r.details ?? '',
    ].map(v => `"${String(v).replace(/"/g, '""')}"`).join(';'))
    .join('\r\n');
  const blob = new Blob([BOM + header + body], { type: 'text/csv;charset=utf-8' });
  const link = document.createElement('a');
  link.href     = URL.createObjectURL(blob);
  link.download = `AMed_AuditLog_${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}
